module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showModal) ? _c('div', {
    ref: "modal",
    staticClass: "cb-modal",
    class: {
      'cb-modal--overlay': _vm.isDismissible || _vm.overlay
    },
    attrs: {
      "role": "alert"
    }
  }, [_c('div', {
    staticClass: "cb-modal__wrap",
    style: (!(_vm.isDismissible || _vm.overlay) && _vm.backgroundColor)
  }, [_c('div', {
    staticClass: "cb-modal__content",
    class: {
      'cb-modal__content--inline': !(_vm.isDismissible || _vm.overlay)
    }
  }, [(_vm.icon) ? _c('div', {
    staticClass: "cb-modal__icon",
    style: ((_vm.isDismissible || _vm.overlay) && _vm.themeColor)
  }, [(_vm.icon == 'info') ? _c('i', {
    staticClass: "icon-info-circle"
  }) : _c('i', {
    staticClass: "icon-exclamation-circle"
  })]) : _vm._e(), _vm._v(" "), (_vm.text) ? _c('div', {
    staticClass: "cb-modal__text"
  }, [_vm._v("\n          " + _vm._s(_vm.text) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('cb-notes', {
    staticClass: "cb-notebar--footer",
    attrs: {
      "custom-class": 'cb-section',
      "type": 'muted',
      "message": _vm.extraInfo
    },
    slot: "notes"
  })], 1), _vm._v(" "), (_vm.isDismissible) ? _c('div', {
    staticClass: "cb-modal__actions"
  }, [(_vm.isDismissible) ? _c('button-field', {
    staticClass: "cb-modal__action",
    attrs: {
      "custom-class": 'primary',
      "showLoader": _vm.showLoader,
      "attr": 'modal_secondary_action'
    },
    on: {
      "next": function($event) {
        _vm.closeModal()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.t('modal_button.cancel')) + "\n        ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.primaryAction || _vm.secondaryAction) ? _c('div', {
    staticClass: "cb-modal__actions"
  }, [(_vm.primaryAction) ? _c('button-field', {
    staticClass: "cb-modal__action",
    attrs: {
      "custom-class": 'primary',
      "showLoader": _vm.showLoader,
      "attr": 'modal_primary_action'
    },
    on: {
      "next": function($event) {
        _vm.next()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.primaryAction) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.secondaryAction) ? _c('div', {
    directives: [{
      name: "cb-link",
      rawName: "v-cb-link",
      value: ('color'),
      expression: "'color'"
    }],
    staticClass: "cb-modal__action",
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v(" " + _vm._s(_vm.secondaryAction) + " ")]) : _vm._e()], 1) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18ebea12"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/collections/elements/ModalBox.vue
// module id = 125
// module chunks = 83 84 85 86